import { PreRenderService } from '../../../services/pre-render.service';
import { OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { RemaxMarker } from '../../../classes/remax-marker';
import { Listing } from '../../../classes/listing';
import { CurrencyPipe } from '@angular/common';
import { Helper } from '../../../classes/helper';
import { ListingsService } from '../../../services/listings.service';
import { GOOGLE_MAP_KEY, GOOGLE_MAP_URL, GOOGLE_MAP_API_URL } from '../../../app-config.constants';
var MapComponent = /** @class */ (function () {
    function MapComponent(currencyPipe, listingService, preRenderService) {
        var _this = this;
        this.currencyPipe = currencyPipe;
        this.listingService = listingService;
        this.preRenderService = preRenderService;
        this.isOffice = false;
        this.customMapOptions = {};
        this.mapOptions = {
            fullscreenControl: false,
            mapTypeControl: false,
            zoomControl: true,
            streetViewControl: true,
            zoom: 17,
            disableDefaultUI: false,
            draggable: true,
            scrollwheel: true,
            minZoom: 3,
            center: {
                lat: 0,
                lng: 0
            }
        };
        this.mapEnabled = true;
        this.zoomLevel = 17;
        this.mapImageWidth = 700;
        this.mapImageHeight = 400;
        this.isNotLuxuryListingDetailPage = false;
        this.addBImg = {};
        this.setmapAttributes = function () {
            if (!_this.listing || !_this.listing.lat || !_this.listing.lng)
                return;
            _this.mapRedirectUrl = GOOGLE_MAP_URL + '?q=' + _this.listing.lat + ',' + _this.listing.lng;
            _this.mapImage = GOOGLE_MAP_API_URL + 'staticmap?center=' + _this.listing.lat + ',' + _this.listing.lng +
                '&zoom=' + _this.zoomLevel + '&scale=false&size=' + _this.mapImageWidth + 'x' + _this.mapImageHeight + '&maptype=hybrid&key=' + GOOGLE_MAP_KEY + '&format=png&visual_refresh=true&markers=icon:https%3A%2F%2Fremax-prodapp.imgix.net%2Fassets%2Fmap-pins%2Foffice-pin.png%3Fw%3D64%26h%3D64%7Cshadow:true%7C'
                + _this.listing.lat + ',' + _this.listing.lng;
            _this.addBImg = _this.addStyles(_this.mapImage);
        };
        this.mapEnabled = this.preRenderService.isBrowserMode;
    }
    MapComponent.prototype.ngAfterViewInit = function () {
        this.setmapAttributes();
    };
    MapComponent.prototype.ngOnChanges = function (changes) {
        for (var key in this.customMapOptions) {
            this.mapOptions[key] = this.customMapOptions[key];
        }
    };
    Object.defineProperty(MapComponent.prototype, "isLDP", {
        set: function (isLDP) {
            var _this = this;
            this.isNotLuxuryListingDetailPage = isLDP;
            if (this.listing) {
                this.listingService.getPriceOrPricePerSqFtString(this.listing).toPromise().then(function (str) { return _this.priceOrPricePerSqFt = str; });
                var price = isLDP ? this.priceOrPricePerSqFt : Helper.formatPrice(this.listing.listPrice);
                this.marker = RemaxMarker.generateListingMarkerFromListing(price, this.listing);
                this.mapOptions.center = {
                    lat: this.listing.lat,
                    lng: this.listing.lng
                };
            }
            else if (this.latLng) {
                this.mapOptions.center = this.latLng;
                this.marker = RemaxMarker.generatePlainMarker(false, this.isOffice, this.latLng);
            }
        },
        enumerable: true,
        configurable: true
    });
    MapComponent.prototype.addStyles = function (url) {
        return {
            'background-image': 'url(' + url + ')'
        };
    };
    return MapComponent;
}());
export { MapComponent };
